const NO_TITLES = Object.freeze({});

/**
 * Mag een grafiek de namen van meetmomenten tonen, of alleen hun positie?
 *
 * Grafieken groeperen antwoorden op de POSITIE van het meetmoment, over alle
 * onderzoeken heen. De naam bij een positie komt van één onderzoek. Komen de
 * antwoorden uit meerdere onderzoeken, dan hoort die naam bij een meting waar
 * de antwoorden niet vandaan komen — bij Groentjessoep heette een staaf
 * 'nameting november 24' terwijl de antwoorden van twee andere scholen uit
 * 2026 waren. Dan tonen we alleen 'Meetmoment 2'.
 *
 * Een antwoord zonder `ResearchID` telt als een eigen onderzoek: bij twijfel
 * liever een positie dan een naam die niet klopt.
 *
 * @param {Object<number, string>} pos2title - Positie → naam van één onderzoek
 * @param {Array<{ResearchID?: string}>|undefined} records - De antwoorden in de grafiek
 * @returns {Object<number, string>} `pos2title`, of een leeg object bij meerdere onderzoeken
 */
const momentTitlesForRecords = (pos2title, records) => {
    const researches = new Set((Array.isArray(records) ? records : []).map((r) => r?.ResearchID || ''));
    return researches.size > 1 ? NO_TITLES : pos2title;
};

export default momentTitlesForRecords;
